export const PercentCellRenderer = ({ value, colDef }) => {

  if (value == null) {
    return <span />;
  }

  const percentNf = new Intl.NumberFormat('en-US', {
      maximumFractionDigits: colDef.decimalPrecision,
  });
  
  let percent = percentNf.format(value * 100) + '%';

  return (
    <span cell-value={value} title={value} style={{ contentVisibility: 'auto', display: 'flex', justifyContent: 'flex-end' }}>
        {percent}
    </span>
  );
  

}